import { render, staticRenderFns } from "./BlackIpList.vue?vue&type=template&id=6d40091f&scoped=true"
import script from "./BlackIpList.vue?vue&type=script&lang=js"
export * from "./BlackIpList.vue?vue&type=script&lang=js"
import style0 from "./BlackIpList.vue?vue&type=style&index=0&id=6d40091f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d40091f",
  null
  
)

export default component.exports